import Immutable from 'immutable';

const LOAD_LIST = 'aws-bucket/LOAD';
const LOAD_LIST_SUCCESS = 'aws-bucket/LOAD_SUCCESS';
const LOAD_LIST_FAIL = 'aws-bucket/LOAD_FAIL';

const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    loading: false,
    items: [],
    count: 0
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_LIST:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case LOAD_LIST_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('items', action.items)
                .set('itemsCount', action.count);

        case LOAD_LIST_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('items', null);
        default:
            return state;
    }
}

export const loadList = (bucket, prefix) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_LIST });
    try {
        const result = await api.get(`/aws-bucket/${bucket}/${encodeURIComponent(prefix)}`);
        if (!result) {
            dispatch({ type: LOAD_LIST_FAIL, error: result.message });
            return [];
        }
        dispatch({ type: LOAD_LIST_SUCCESS, items: result, count: result.count });
        return result;
    } catch (error) {
        let errorMessage = error.message;
        if (error.statusCode === 403) {
            errorMessage = "You are not authorized to access this page";
        }
        dispatch({ type: LOAD_LIST_FAIL, error: errorMessage });
        return [];
    }
};

export const copyObject = (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_LIST });
    try {
        const result = await api.post(`/aws-bucket/copy`, {data});
        if (!result) {
            dispatch({ type: LOAD_LIST_FAIL, error: result.message });
            return;
        }
        dispatch({ type: LOAD_LIST_SUCCESS, items: result, count: result.count });
        return result;
    } catch (error) {
        dispatch({ type: LOAD_LIST_FAIL, error: error.message });
    }
};